module.exports = __webpack_public_path__ + "img/assigned-patients-clinician-dashboard.aa19e6c6.png";